export const actions = {
  addNode: 'Add step',
  addStage: 'Add stage',
  publish: 'Publish',
  manageActionStages: 'Manage stages',
  manageSignature: 'Manage signature',
  manageRules: 'Manage rules',
  manageIndexes: 'Manage product indexes',
  manageFlow: 'Manage configuration template',
  manageModels: 'Manage models',
  manageGroups: 'Manage groups',
  managePackages: 'Manage packages',
  manageLabels: 'Manage labels',
  previewGroups: 'Preview groups',
  previewPackages: 'Preview packages',
  previewFlow: 'Preview configuration template',
  previewRules: 'Preview rules',
  previewActionStages: 'Preview stages',
  previewSignature: 'Preview signatures',
  previewIndexes: 'Preview product indexes',
  manageControls: 'Manage controls',
  previewControls: 'Preview controls',
  previewLabels: 'Preview labels',
} as const
